import { Container } from '@mantine/core'
import { BarChart } from '@ospace/shared/components/BarChart'

import { LeadsStatsData } from '../hooks/useLeadsStats'

type Props = {
  stats: LeadsStatsData
}

const barChartColours = ({ id }: { id: string | number }) => {
  switch (id) {
    case 'companies':
      return '#FFA53F'

    case 'leads':
      return '#C9D14D'

    case 'meetings':
      return '#65C869'

    default:
      return '#ff0000'
  }
}

export const LeadsBarChart = ({ stats }: Props) => {
  return (
    <BarChart
      title='MONTHLY RESULTS'
      barChartTooltip='The chart displays the companies that have been discovered, turned into a lead, or turned into a meeting during the selected time period.'
      keys={['companies', 'leads', 'meetings']}
      colors={barChartColours}
      data={stats.barChart || []}
      indexBy='month'
      tooltip={({ value, color }) => (
        <Container c={color} bg='#222222' p={12}>
          <strong>{value}</strong>
        </Container>
      )}
      axisLeftFormat={(value) => `${value}`}
      label={(item) => item?.value || 0}
      legendItemWidth={100}
    />
  )
}
